<template>
  <div v-if="model.results.length">
    <div>
      <span v-if="model.results">
        <b><translate>Results</translate>: {{ model.params.resortName}} -
          {{ model.params.checkIn }} /
          {{ duration }} <translate>nights</translate></b>,&nbsp;
        <span v-for="(room, index) in model.params.rooms" :key="index">
          <span class="tag-details"><translate>Room:</translate> {{index + 1 }} - </span>
          <span>{{room.adults}} </span><span class="name-details" v-translate> adults</span>
          <span v-if="room.ages && room.ages.length" class="name-details">, {{ room.ages.length }} <translate>children</translate>  - <translate>age</translate>:
            {{ room.ages.join(', ')}}
          </span>,
        </span>
        <strong>&nbsp;{{ model.results.length }}</strong> <translate>results</translate>
        <!-- {{ model.params}} -->
      </span>
      <span v-else v-translate>
        There are no results for your search.
        Please change your search criteria
      </span>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import model from '../services/model'

export default {
  name: 'SearchResultsSummary',
  params: ['params'],
  data () {
    return {
      model
    }
  },
  computed: {
    duration () {
      return moment(model.params.checkOut, 'DD-MM-YYYY').startOf('day').diff(moment(model.params.checkIn, 'DD-MM-YYYY').startOf('day'), 'days')
    }
  }
}
</script>

<style>
.results {
  background-color: rgb(112, 99, 90);
  padding: 10px;
  color: #fff;
  border-radius: 4px;
}
.breadcrumb li {
  font-size: 13px;
  text-align: center;
}
.SPOEBD {
  font-size: 14px;
  font-weight: 600;
  color: #d13239;
}

.RQNA {
  font-size: 14px;
  font-weight: 600;
  color: #000;
}
.FCAVL {
  font-size: 14px;
  font-weight: 600;
  color: green;
}
</style>
